/* ============================================================
   SPITBALL — SMS CAPTURE (Klaviyo Client Subscribe API)

   Shopify's {% form 'customer' %} does NOT accept contact[phone],
   and there is no Liquid field for SMS marketing consent at all.
   Numbers and consent go to Klaviyo directly.

   Compliance (TCPA / CTIA) — do not "simplify" these away:
   - Consent must be an explicit, unchecked, optional action.
   - The email-only path must always still work.
   - The disclosure must sit next to the control that gives consent.
   ============================================================ */

(function () {
  'use strict';

  /* ==========================================================
     CONFIG — the only thing you need to fill in.
     Klaviyo > Audience > Lists & Segments > (your SMS list)
       > Settings > List ID
     While listId is blank every SMS control on the site stays
     hidden, so nothing can collect a number it can't store.
     ========================================================== */
  //
  // NOTE: companyId here is XG2mSY, which is NOT the account the Klaviyo
  // Shopify app embed loads on the storefront (that one is V2DJhL). Two
  // separate Klaviyo accounts exist. The SMS list and the carrier
  // registration both live in XG2mSY, so that's what this posts to.
  // Verified against the live API on 2026-09-14: XG2mSY + WXWCbR returns
  // 202; V2DJhL + WXWCbR returns "List not found".
  var KLAVIYO = {
    companyId: 'XG2mSY',
    listId: 'WXWCbR'
  };

  // Klaviyo pins behaviour to this header. Verified against the live API
  // on 2026-09-14: at 2024-10-15 the endpoint rejects the `subscriptions`
  // block outright ("not a valid field for the resource 'profile'"), which
  // silently kills every SMS consent write. Do not lower this without
  // re-probing the API.
  var REVISION = '2026-07-15';

  function isReady() { return !!(KLAVIYO.companyId && KLAVIYO.listId); }

  // US-only on purpose: the store ships US and 10DLC is US carriers.
  function toE164(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    if (d.length === 10) return '+1' + d;
    return null;
  }

  function subscribe(opts) {
    if (!isReady()) return Promise.resolve(false);

    var subs = {};
    if (opts.email) subs.email = { marketing: { consent: 'SUBSCRIBED' } };
    if (opts.phone) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };

    var attrs = { subscriptions: subs };
    if (opts.email) attrs.email = opts.email;
    if (opts.phone) attrs.phone_number = opts.phone;

    var props = {};
    if (opts.sport) props.sport = opts.sport;
    if (window.SB_FLYER) props.flyer = window.SB_FLYER;
    if (Object.keys(props).length) attrs.properties = props;

    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO.companyId),
      {
        method: 'POST',
        keepalive: true,   // survives a native form navigating away
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: opts.source || 'Spitball Site',
              profile: { data: { type: 'profile', attributes: attrs } }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO.listId } } }
          }
        })
      }
    ).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  /* ---- checkbox style opt-in (lead capture section) ---------- */

  function wireCheckbox(root) {
    var box   = root.querySelector('[data-sb-sms-consent]');
    var phone = root.querySelector('[data-sb-sms-phone]');
    var wrap  = root.querySelector('[data-sb-sms-reveal]');
    var err   = root.querySelector('[data-sb-sms-error]');
    if (!box || !phone) return;

    box.addEventListener('change', function () {
      if (wrap) wrap.classList.toggle('is-visible', box.checked);
      phone.required = box.checked;
      if (box.checked) phone.focus();
      else if (err) err.textContent = '';
    });

    var form = root.closest('form');
    if (!form) return;

    // Native submit only — never preventDefault a Shopify customer form
    // on the success path: its bot protection injects a CAPTCHA token
    // during that event, and skipping it gets the signup rejected.
    form.addEventListener('submit', function (e) {
      if (!box.checked) return;

      var e164 = toE164(phone.value);
      if (!e164) {
        e.preventDefault();
        if (err) err.textContent = 'That doesn\u2019t look like a 10-digit US number.';
        phone.focus();
        return;
      }
      if (err) err.textContent = '';

      var emailEl = form.querySelector('input[type="email"]');
      subscribe({
        email:  emailEl ? emailEl.value : null,
        phone:  e164,
        source: root.getAttribute('data-source')
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-sb-sms]').forEach(function (root) {
      if (!isReady()) { root.hidden = true; return; }   // no list = no collecting
      root.hidden = false;
      wireCheckbox(root);
    });
    document.querySelectorAll('[data-sb-sms-gate]').forEach(function (el) {
      el.hidden = !isReady();
    });
  }

  window.SpitballSMS = {
    isReady: isReady,
    toE164: toE164,
    subscribe: subscribe
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
